import styled from "styled-components";
import Dialog from "../../../components/dialog/dialog";

export const CreateProjectModalStyled = styled(Dialog)`
  width: ${({ isGrouped }) => (isGrouped ? "50%" : "70%")};
  /* height: 90%; */
  button{
    color: #301d35 !important;
    border: 1px solid #301d35;
  }

  .confirm-btn {
    width: 160px;
  }
  button:hover {
    background-color: #dedafb !important;
  }
  .head {
    margin-bottom: 20px;
  }
  .dialog-body {
    padding: 20px;
  }
`;
